import { getAutocompleteConfig } from 'common/dynamic-form/types/autocomplete-select/autocomplete-select.utils';
import { getBannerConfig } from 'common/dynamic-form/types/banner/banner.utils';
import { getButtonConfig } from 'common/dynamic-form/types/button/button.utils';
import { getCaptchaConfig } from 'common/dynamic-form/types/captcha/captcha.utils';
import { getChatSummaryConfig } from 'common/dynamic-form/types/chat-summary/chat-summary.utils';
import { getChatConfig } from 'common/dynamic-form/types/chat/chat.utils';
import { getCheckboxConfig } from 'common/dynamic-form/types/checkbox/checkbox.utils';
import { getColorPickerConfig } from 'common/dynamic-form/types/color-picker/color-picker.utils';
import { getDatePickerConfig } from 'common/dynamic-form/types/date-picker/date-picker.utils';
import { getDateTimeConfig } from 'common/dynamic-form/types/datetime/datetime.utils';
import { getInputFileConfig } from 'common/dynamic-form/types/file/file.utils';
import { getFormScrollerConfig } from 'common/dynamic-form/types/form-scroller/form-scroller.utils';
import { getFrameConfig } from 'common/dynamic-form/types/frame/frame.utils';
import { getHiddenConfig } from 'common/dynamic-form/types/hidden/hidden.utils';
import { getInputTextConfig } from 'common/dynamic-form/types/input/input.utils';
import { getLinkConfig } from 'common/dynamic-form/types/link/link.utils';
import { getListFilterConfig } from 'common/dynamic-form/types/list-filter/list-filter.utils';
import { getListConfig } from 'common/dynamic-form/types/list/list.utils';
import { getOTPConfig } from 'common/dynamic-form/types/otp/otp.utils';
import { getPasswordConfig } from 'common/dynamic-form/types/password/password.utils';
import { getPhoneConfig } from 'common/dynamic-form/types/phone/phone.utils';
import { getPromoCodeConfig } from 'common/dynamic-form/types/promo-code/promo-code.utils';
import { getRadioConfig } from 'common/dynamic-form/types/radio/radio.utils';
import { getRadioImgConfig } from 'common/dynamic-form/types/radioimg/radioimg.utils';
import { getReflectConfig } from 'common/dynamic-form/types/reflect/reflect.utils';
import { getSelectConfig } from 'common/dynamic-form/types/select/select.utils';
import { getSliderConfig } from 'common/dynamic-form/types/slider/slider.utils';
import { getSwitcherSelectConfig } from 'common/dynamic-form/types/switcher-select/switcher-select.utils';
import { getSwitcherConfig } from 'common/dynamic-form/types/switcher/switcher.utils';
import { getTextareaConfig } from 'common/dynamic-form/types/textarea/textarea.utils';
import { getTextDataConfig } from 'common/dynamic-form/types/textdata/textdata.utils';
import { getTotalSumConfig } from 'common/dynamic-form/types/total-sum/total-sum.utils';
import { getTreeConfig } from 'common/dynamic-form/types/tree/tree.utils';
import {
  BannerControl,
  ButtonControl,
  CaptchaControl,
  SelectControlWithValue,
  AutocompleteSelectControlWithValue,
  SwitcherControlWithValue,
  RadioControlWithValue,
  RadioImgControlWithValue,
  ReflectControl,
  DateTimeControlWithValue,
  TextAreaControlWithValue,
  LinkControl,
  InputControlWithValue,
  OTPControlWithValue,
  CheckboxControlWithValue,
  DatepickerControlWithValue,
  ColorpickerControlWithValue,
  FileControlWithValue,
  PasswordControlWithValue,
  HiddenControlWithValue,
  ListControl,
  ListFilterControlWithValue,
  TextDataControl,
  TotalSumControl,
  FrameControlWithValue,
  SliderControlWithValue,
  TreeControlWithValue,
  TicketControlWithValue,
  TicketInfo,
  TicketFormScroller,
} from 'common/dynamic-form/utils/form-preparing';
import {
  PhoneControlWithValue,
  PromocodeControlWithValue,
} from 'common/dynamic-form/utils/form-preparing/combined';

import { ISPConfigMappers } from './model/config-mapper.interface';

export const INITIAL_MAPPERS: Omit<ISPConfigMappers, 'code' | 'texteditor'> = {
  banner: (control: BannerControl, field, state) =>
    getBannerConfig(control.control, field.field, state),
  button: (control: ButtonControl, field, state) =>
    getButtonConfig(control.control, field.field, state),
  captcha: (control: CaptchaControl, field, state) =>
    getCaptchaConfig(control.control, field.field, state),
  select: (control: SelectControlWithValue, field, state) =>
    getSelectConfig(control, state),
  autocomplete: (control: AutocompleteSelectControlWithValue, field, state) =>
    getAutocompleteConfig(control.control, field.field, state),
  switcher: (control: SwitcherControlWithValue, field, state) =>
    getSwitcherConfig(control.control, field.field, state),
  switcherSelect: (control: SwitcherControlWithValue, field, state) =>
    getSwitcherSelectConfig(control, state),
  radio: (control: RadioControlWithValue, field, state) =>
    getRadioConfig(control.control, field.field, state),
  radioimg: (control: RadioImgControlWithValue, field, state) =>
    getRadioImgConfig(control.control, field.field, state),
  reflect: (control: ReflectControl, field, state) =>
    getReflectConfig(control.control, field.field, state),
  datetime: (control: DateTimeControlWithValue, field, state) =>
    getDateTimeConfig(control.control, field.field, state),
  textarea: (control: TextAreaControlWithValue, field, state) =>
    getTextareaConfig(control.control, field.field, state),
  link: (control: LinkControl, field, state) =>
    getLinkConfig(control.control, field.field, state),
  input: (control: InputControlWithValue, field, state) =>
    getInputTextConfig(control.control, field.field, state),
  otp: (control: OTPControlWithValue, field, state) =>
    getOTPConfig(control.control, field.field, state),
  checkbox: (control: CheckboxControlWithValue, field, state) =>
    getCheckboxConfig(control.control, field.field, state),
  datepicker: (control: DatepickerControlWithValue, field, state) =>
    getDatePickerConfig(control.control, field.field, state),
  colorpicker: (control: ColorpickerControlWithValue, field, state) =>
    getColorPickerConfig(control.control, field.field, state),
  file: (control: FileControlWithValue, field, state) =>
    getInputFileConfig(control.control, field.field, state),
  password: (control: PasswordControlWithValue, field, state) =>
    getPasswordConfig(control.control, field.field, state),
  promocode: (control: PromocodeControlWithValue, field, state) =>
    getPromoCodeConfig(control.control, control.button, field.field, state),
  phone: (control: PhoneControlWithValue, field, state) =>
    getPhoneConfig(control, field.field, state),
  hidden: (control: HiddenControlWithValue, field) =>
    getHiddenConfig(control.control, field.field),
  list: (control: ListControl, field, state) =>
    getListConfig(control.control, field.field, state),
  listfilter: (control: ListFilterControlWithValue, field, state) =>
    getListFilterConfig(control, field.field, state),
  textdata: (control: TextDataControl, field, state) =>
    getTextDataConfig(control.control, field.field, state),
  totalsum: (control: TotalSumControl, field, state) =>
    getTotalSumConfig(control.control, field.field, state),
  frame: (control: FrameControlWithValue, field, state) =>
    getFrameConfig(control.control, field.field, state),
  slider: (control: SliderControlWithValue, field, state) =>
    getSliderConfig(control.control, field.field, state),
  tree: (control: TreeControlWithValue, field, state) =>
    getTreeConfig(control.control, field.field, state),
  ticket: (control: TicketControlWithValue, field, state) =>
    getChatConfig(control.control, field.field, state),
  ticketinfo: (control: TicketInfo, field, state) =>
    getChatSummaryConfig(control.control, state),
  scroller: (control: TicketFormScroller, field, state) =>
    getFormScrollerConfig(control.control, state),
  // @WARN this fields are dynamically loaded
  // texteditor: (control: TextEditorControlWithValue, field, state) =>
  //   getTextEditorConfig(control.control, field.field, state),
  // code: (control: CodeControlWithValue, field, state) =>
  //   getCodeConfig(control.control, field.field, state),
};
